import { DashboardService } from "../../../dashboard.service";
import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../../accountant/accountant.service";
import { MyAccountService } from "../modals/my-account-modal.service";
import { UntypedFormBuilder, FormGroup, FormControl, Validators, FormsModule } from "@angular/forms";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { FormUtil } from "../../../../utils/formutils";
import { HotToastService } from "@ngneat/hot-toast";
import { Router } from "@angular/router";

declare var jQuery: any;

@Component({
    selector: "preferences-modal",
    templateUrl: "./preferences-modal.component.html",
    imports: [FormsModule]
})
export class PreferencesModalComponent implements OnInit {
  user: any = {};
  data: any = {};
  one_signal = window["OneSignal"] || [];
  has_web_push_enabled = null;

  constructor(
    public bsModalRef: BsModalRef,
    private accountantService: AccountantService,
    private dashboardService: DashboardService,
    private myAccountService: MyAccountService,
    private formBuilder: UntypedFormBuilder,
    private localStorage: LocalStorageService,
    private toastr: HotToastService,
    private router: Router,
    private _elRef: ElementRef,
    vcr: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.user = this.localStorage.get("user");
    this.data = this.localStorage.get("data");
    this.one_signal = window["OneSignal"] || [];
    this.has_web_push_enabled = this.data["has_web_push_enabled"];
    this.one_signal.push(() => {
      //   Occurs when the user's subscription changes to a new value.
      this.one_signal.on("subscriptionChange", (isSubscribed) => {
        console.log("The user's subscription state is now:", isSubscribed);
        this.myAccountService.update_has_web_push(isSubscribed);
        this.one_signal.getUserId().then((userId) => {
          console.log("User ID is", userId);
          if (userId)
            this.myAccountService.set_push_keys({
              userId: userId,
              type: "WEB",
            });
        });
      });

      // this.one_signal.isPushNotificationsEnabled().then(isEnabled => {
      //   console.log("is push enabled?", isEnabled);
      //   this.has_web_push_enabled = isEnabled;
      //   this.myAccountService.update_has_web_push(isEnabled);
      // });
    });
  }

  toggleWebPushNotifications() {
    this.has_web_push_enabled = !this.has_web_push_enabled;
    if (this.has_web_push_enabled) {
      this.one_signal.push(() => {
        console.log("Register For Push");
        this.one_signal.push(["registerForPushNotifications"]);
      });
    } else {
      this.myAccountService.update_has_web_push(this.has_web_push_enabled);
    }

    this.one_signal.getUserId().then((userId) => {
      console.log("User ID is", userId);
      if (userId) {
        console.log("sending push keys");
        this.myAccountService.set_push_keys({ userId: userId, type: "WEB" });
      }
    });
  }
}
